module.exports = __webpack_public_path__ + "img/salon-entertainment.8d08a0cc.svg";